import { NewRequestAction } from "./actions";
import { NewRequestState } from "../model/form.model";
import { initialNewRequestState } from "./initial";

export function newRequestReducer(
  state: NewRequestState,
  action: NewRequestAction
): NewRequestState {
  switch (action.type) {
    case "purchase/loadingCustomer":
      return {
        ...state,
        purchase: { ...state.purchase, loadingCustomer: action.value },
      };
    case "purchase/loadingDates":
      return {
        ...state,
        purchase: { ...state.purchase, loadingDates: action.value },
      };
    case "purchase/setCustomer":
      return {
        ...state,
        purchase: { ...state.purchase, customer: action.value },
      };

    case "purchase/setDates":
      return {
        ...state,
        purchase: { ...state.purchase, availableDates: action.value },
      };

    case "purchase/setLastPayment":
      return {
        ...state,
        lastPayment: action.value,
      };

    case "purchase/setError":
      return { ...state, purchase: { ...state.purchase, error: action.value } };

    case "purchase/reset":
      return {
        ...state,
        purchase: {
          ...initialNewRequestState.purchase,
          customersOptions: state.purchase.customersOptions,
        },
        products: { ...initialNewRequestState.products },
      };

    case "purchase/setCompanies":
      return {
        ...state,
        purchase: { ...state.purchase, customersOptions: action.value },
      };

    // ---------------- products ----------------
    case "products/setCart":
      return { ...state, products: { ...state.products, cart: action.value } };

    case "products/setPricingStatus":
      return {
        ...state,
        products: { ...state.products, pricingStatus: action.value },
      };

    case "products/setError":
      return { ...state, products: { ...state.products, error: action.value } };

    case "products/reset":
      return { ...state, products: { ...initialNewRequestState.products } };

    case "reset/all":
      return {
        ...state,
        purchase: {
          ...initialNewRequestState.purchase,
          customersOptions: state.purchase.customersOptions,
        },
        products: { ...initialNewRequestState.products },
      };

    default:
      return state;
  }
}
